import { map, pipe, range } from "rambda"

import { IS_PROD, password, VERCEL_SERVER_URL } from "../../config/constants"
import { BaseCache } from "./base-cache"

const MOCK_RESPONSE = [
  "Тогава кога си ние ние",
  "тогава ние бяхме ти",
  "и си ли ти и аз те търсех",
  "може би е време за да ти кажа, че аз съм те обичал",
  "и че не съм ябълка, но аз съм много хубава",
  "и че искам да те обичам",
  "може и тълпата да не каже заветните слова",
  "но аз ще кажа, че те обичам",
]

const MOCK_RESPONSE_JOKES = [
  "Какво мислите за човек, който е като дете? Той винаги казва истината.",
  "Кой е единственият американски президент, който е бил и боец?",
  "Кой е единственият български президент, който е бил и боец?",
  "има ли необичайно добър български президент?",
  "има ли специално българско послание за любимите деца?",
  "къде е пропуснатият знак?",
  "когато си малък, как е по-добре да се назовеш?",
]

export const MOCK_CANDIDATES = [...MOCK_RESPONSE, ...MOCK_RESPONSE_JOKES]
const URL_BASE = `${VERCEL_SERVER_URL}/short-sentences`

const ENDPOINTS: Record<ShortSentencesMode, string> = {
  "funny-literature-non-questions": `${URL_BASE}/funny-literature-non-questions.json`,
  "funny-literature-questions": `${URL_BASE}/funny-literature-questions.json`,
  "jokes-non-questions": `${URL_BASE}/jokes-non-questions.json`,
  "jokes-questions": `${URL_BASE}/jokes-questions.json`,
  "literature-non-questions": `${URL_BASE}/literature-non-questions.json`,
  "literature-questions": `${URL_BASE}/literature-questions.json`,
  "short-jokes-non-questions": `${URL_BASE}/short-jokes-non-questions.json`,
  "short-jokes-questions": `${URL_BASE}/short-jokes-questions.json`,
  "short-non-questions": `${URL_BASE}/short-non-questions.json`,
  "short-questions": `${URL_BASE}/short-questions.json`,
}

class ProtectedJsonCache extends BaseCache {
  password = password

  constructor() {
    super("protected-json-cache")
  }

  async deleteAll() {
    await Promise.all(
      Object.values(ENDPOINTS).map(async endpoint=> {
        await this.cache?.delete(endpoint)
      }),
    )
  }

  async getJson(endpointKey: keyof typeof ENDPOINTS): Promise<string[]> {
    if (!IS_PROD) {
      return getMockResponse(
        endpointKey.includes("jokes") ? MOCK_RESPONSE_JOKES : MOCK_RESPONSE,
      )
    }
    const url = ENDPOINTS[endpointKey]
    if (!this.cache) {
      await this.init()
    }
    if (!this.cache) {
      throw new Error("Cache API not supported")
    }

    const cachedResponse = await this.cache.match(url)
    if (cachedResponse) {
      return cachedResponse.json()
    }

    try {
      const reqHeaders = new Headers()
      if (!this.password) {
        throw new Error("missing password")
      }

      reqHeaders.set("x-password", this.password)
      const options = {
        headers: reqHeaders,
      }
      const req = new Request(url, options)
      const response = await fetch(req)
      if (response.ok) {
        this.cache.put(url, response.clone())
        return response.json()
      }
      throw new Error(`Failed to fetch json: ${url}`)
    } catch {
      throw new Error(`Failed to cache json: ${url}`)
    }
  }
}
function getMockResponse(list: string[]) {
  return pipe(
    range(100),
    map(x=> list.map(xx=> xx + x)),
    x=> x.flat(),
  )
}

export const protectedJsonCache = new ProtectedJsonCache()
